<template>
	<v-dialog v-model="dialog" :max-width="520" @click:outside="onClose">
		<div class="relative bg-white rounded d-flex flex-column justify-center pb-5">
			<div class="text-center">
				<v-img
					:src="assetsUrl('img/logo.png')"
					class="mx-auto mb-4"
					style="margin-top: -60px"
					:width="80"
					:height="80" />
			</div>

			<div class="px-4 d-flex justify-center">
        <div
          v-if="!Array.isArray(popupContent)"
          class="popup-content"
        >
          {{ popupContent }}
        </div>
				<ul class="ul-1" v-else>
					<li v-for="(val, key) in popupContent" :key="key">
						{{ val }}
					</li>
				</ul>
			</div>

			<div class="text-center mt-4">
				<v-btn
					class="text-white"
					color="primary"
					elevation="0"
					@click="onClose"
					style="min-width: 120px">
					Ok
				</v-btn>
			</div>
		</div>
	</v-dialog>
</template>
<script>
import { useAppMessageStore } from '@/stores/appMessage';

export default {
  name: 'GlobalMessageModal',
  data () {
    return {
      dialog: false,
			appNotifyStore: useAppMessageStore()
    }
  },
	computed: {
    message () {
      return this.appNotifyStore.getMessage
    },
    hasErrorFromServer () {
      return this.appNotifyStore.hasErrorFromServer
    },
    popupContent () {
      if (this.message?.constructor !== Object) return this.message;
			return this.getContent(this.message);
    },
	},
  watch: {
    message (val) {
      this.dialog = !!val;
    }
  },
	methods: {
    onClose () {
			this.dialog = false;

      const callback = this.appNotifyStore.onCloseCallback;
      setTimeout(() => {
				this.appNotifyStore.setMessage();
        this.appNotifyStore.onCloseCallback = null;
        if (callback) callback();
			}, 400)
    },
    getContent (message = {}) {
			if (!this.hasErrorFromServer) return message;

			// bug 500, 404, or undefined bugs from the serser
			const messageData = message.data?.data;
			if (
				!messageData
				|| messageData.constructor !== Object
				|| !Object.keys(messageData).length
			) {
				return message.data?.error || message;
			}

      /**
			 * Error response format
			 * from server (may be changed):
			 * message = {
			 *  data: {
			 *   data: {...}
			 *  },...
			 * }
			 */
			message.errors = JSON.parse(JSON.stringify(messageData));

      const messageArr = [];
      for (const key in message.errors) {
        messageArr.push( message.errors[key])
      }

      return [...messageArr];
    }
	},
};
</script>
<style lang="scss" scoped>
.ul-1 {
	list-style-type: none;
	li {
		&:not(:last-child) { margin-bottom: 12px; }
	}
}
.popup-content {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
